















































































































































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwIcon } from '@libs-uuif/shared/sw-icon';
import { SwScrollView } from '@libs-uuif/shared/sw-scroll-view';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { UserGroupStoreState } from '@/modules/msw-products/components/msw-user-group/store';
import { State } from 'vuex-class';
import { RootStoreState } from '../../../store';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { tooltip, TooltipDirValues } from '@libs-uuif/shared/tooltip-dir';
import { confirmService } from '@libs-uuif/shared/confirm-service';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
import { MswApiService } from '@/shared/msw-api-service';
import { currentUserKey } from '../../msw-constants';
import * as decode from 'jwt-decode';
// import SwScrollViewScrollbar from '../../dropdown-main/scroll-view-dropdown-scrollbar.vue';

const cssPrefix = 'create-user-group';

@Component({
  components: {
    ...UUIFComponents,
    SwCheckbox,
    SwIcon,
    SwFormRow,
    SwForm,
    SwScrollView,
    SwTextfield,
    SwSelect,
    SwExpandableTextfield,
    SwIconButton,
  },
  directives: {
    tooltip,
  },
})

export default class CreateUserGroup extends SwExtendedVue {
  cssPrefix = cssPrefix;
  userGroupTabDetails: any = [];
  showTabContainer: boolean = false;
  enterNewUserGroup: boolean = false;
  newUserGroup: string = '';
  checkSelectFlag : boolean = false;
  oldPartyGroupId: string = '';
  addFlag: boolean  = false;
  editFlag: boolean = false;
  editIndex: any = 0;
  deleteFlag: boolean = false;
  listItems: any = [];
  selectedListItems: any = [];
  selectedItems: any = [];
  selectedListHeight: string = '';
  selectedGroupFlag: boolean = false;
  createUserGroupTooltipContent: string = '';
  enableCreateUserGroupTooltip: boolean = false;
  editing : boolean = false;
  editUserGroupName: string = '';
  cancelFlag: boolean = false;
  isExpandSearchFilter: boolean = false;
  iconConfig2 = {
    name: 'search',
    color: '#FF791A',
  };
  searchedValue = '';
  upFixClass : boolean = false;
  downFixClass : boolean = false;
  selectedDiv : any;
  lastSelected1 : string = '';
  lastSelected2 : string = '';
  userGroupSelectionChanged : boolean = false;
  startTenantIndex = 0;
  endTenantIndex = 0;
  tempCustomerListVariable : any;
  showLoader : boolean = false;
  showTopLoader : boolean = false;
  stuckInTop : boolean = false;
  setTimeoutId : any =  null;
  searchedAvailableUserGroup : any[] = [];
  searchedUserGroupFlag = false;
  searchModeOn : boolean = false;
  hideRefreshButton : Boolean = false;
  organizationId: string = '';
  selectedAffiliate: string = '';

  @Prop({ type: Array, required: true })
  availableUserGroups: any;

  @Prop({ type: Array, required: false })
  selectedList: any;

  @Prop({ type: Array, required: false })
  selectedItemsProp: any;

  @Prop({ type: Boolean, required: true })
  addUserGroup: Boolean;

  @Prop({ type: String, required: false })
  listHeight: string;

  @Prop({ type: Boolean, required: false })
  scrollUserGroupToTop: boolean;

  @Prop({ type: Boolean, required: false })
  updateCount: Boolean;

  @Prop({ type: Boolean, required: false })
  hideRefresh: Boolean;

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.selectedUserGroup)
  selectedUserGroup: UserGroupStoreState['selectedUserGroup'];

  @State((state: RootStoreState) => state.MswUserGroupStoreModule.hoveredUserGroup)
  hoveredUserGroup: UserGroupStoreState['hoveredUserGroup'];

  @Prop({ type: Boolean, required: true })
  selectMode: Boolean;

  @Prop({ type:String, required: true })
  selectedTab: string;

  @Prop({ type: Boolean, required : false })
  calUpdateUserCount: Boolean;

  @Prop({ type:String, required: false })
  userGroupIdUpdate: string;

  @Watch('calUpdateUserCount')
  updatePermissionChanged() {
    console.warn('calUpdateUserCount no');
    if (this.calUpdateUserCount) {
      const ugId = this.userGroupIdUpdate.split(',')[0];
      const partyId = this.userGroupIdUpdate.split(',')[1];
      const listItemIndex = this.listItems.findIndex((ele : any) => ele.partyGroupId === ugId);
      if (this.userGroupIdUpdate.split(',').length === 2) {
        if (listItemIndex < 0) {
          const selectedListItemsIndex = this.selectedListItems.findIndex((ele : any) => ele.partyGroupId === ugId);
          if (selectedListItemsIndex > -1) {
            const partyIdIndex = this.selectedListItems[selectedListItemsIndex].usersForUserGroup.findIndex((ele: any) => ele.partyId === partyId);
            if (partyIdIndex > -1) {
              this.selectedListItems[selectedListItemsIndex].usersForUserGroup.splice(partyIdIndex, 1);
              this.$set(this.selectedListItems, selectedListItemsIndex, this.selectedListItems[selectedListItemsIndex]);
            }
          }
        } else {
          const partyIdIndex = this.listItems[listItemIndex].usersForUserGroup.findIndex((ele: any) => ele.partyId === partyId);
          if (partyIdIndex > -1) {
            this.listItems[listItemIndex].usersForUserGroup.splice(partyIdIndex, 1);
          }
          this.$set(this.listItems, listItemIndex, this.listItems[listItemIndex]);
        }
      } else {
        MswApiService.createCustomer.getUserGroup()
          .then((resp: any) => {
            const ugMainIndex = resp.userGroups.findIndex((item : any) => item.partyGroupId === ugId);
            console.warn(resp.userGroups[ugMainIndex]);
            if (listItemIndex < 0 && ugMainIndex > -1) {
              const selectedListItemsIndex = this.selectedListItems.findIndex((ele : any) => ele.partyGroupId === ugId);
              if (selectedListItemsIndex > -1) {
                const arr = this.userGroupIdUpdate.split(',');
                this.selectedListItems[selectedListItemsIndex].totalContacts = arr[arr.length - 1]
                .toString();
              }
            } else if (ugMainIndex > -1) {
              const arr = this.userGroupIdUpdate.split(',');
              this.listItems[listItemIndex].totalContacts = arr[arr.length - 1]
                .toString();
            }
          })
          .catch((err: any) => {
            console.warn('getUserGroup failed', err);
          });
      }
    }
  }

  get affiliateGroups(): any {
    return this.$store.getters['MswUserGroupStoreModule/getAffiliateGroupArray'];
  }

  get availableGroupsCopy(): any {
    return JSON.parse(JSON.stringify(this.$store.getters['MswUserGroupStoreModule/getUserGroupResponseCopy']));
  }

  get affiliateGroupOptions(): SelectOption[] {
    this.selectedAffiliate = '0';
    return this.affiliateGroups?.map((ele: any) => {
      return {
        id: ele?.id?.toString(),
        label: ele?.affiliateGroup,
      };
    });
  }

  get showAffiliateDropdown() {
    return this.$route?.path?.includes('user-groups') && this.affiliateGroups?.length > 1;
  }

  onChangeAffiliate() {
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    this.$emit('change-tab-id', 'user-groups-help', false);
    const partyGroupIdsFromSelectedAffiliate: any = [];
    const filteredUserGroupsFromSelectedAffiliate: any = [];
    for (const ele of this.affiliateGroups) {
      if (ele?.id?.toString() === this.selectedAffiliate?.toString()) {
        ele?.partyGroupIds?.forEach((partyGroupId: any) => {
          partyGroupIdsFromSelectedAffiliate.push(partyGroupId);
        });
      }
    }

    for (const userGroup of this.availableGroupsCopy) {
      for (const partyGroup of partyGroupIdsFromSelectedAffiliate) {
        if (partyGroup?.partyGroupId === userGroup?.partyGroupId) {
          filteredUserGroupsFromSelectedAffiliate.push(userGroup);
        }
      }
    }
    this.$emit('updateAvaialableUserGroups', filteredUserGroupsFromSelectedAffiliate);
  }

  showTab() {
    this.showTabContainer = true;
  }

  public focus() {
    // console.log('ele', this.$el, this.$refs);
    // ((this.$refs.userGrp as SwTextfield).$refs.input as HTMLElement).focus();
  }

  // tslint:disable-next-line:no-unused
  handleSearchFilter(e : any) {
    if (this.searchedValue.length > 0) {
      this.searchModeOn = false;
      console.warn(this.availableUserGroups.filter((each : any) => each.partyGroupName.toLowerCase()
    .indexOf(this.searchedValue.toLowerCase()) > -1));
      this.searchedAvailableUserGroup = this.availableUserGroups.filter((each :  any) => each.partyGroupName.toLowerCase()
    .indexOf(this.searchedValue.toLowerCase()) > -1);
      if (this.searchedAvailableUserGroup.length === 0 && this.$store.getters.isLargeCustomer) {
        this.searchUserGroupInApi();
      } else {
        this.searchedUserGroupFlag = true;
        this.startTenantIndex = 0;
        this.endTenantIndex = 0;
        this.getListItems();
        this.searchModeOn = true;
        (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
      }
    } else {
      this.searchedValue = '';
      this.searchedUserGroupFlag = false;
      console.warn(this.availableUserGroups);
      this.startTenantIndex = 0;
      this.endTenantIndex = 0;
      this.getListItems();
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    }
  }
  searchUserGroupInApi() {
    this.$store.commit('startLoading');
    MswApiService.createCustomer.searchUserGroupInApi(this.searchedValue)
    .then((resp: any) => {
      if (resp.hasOwnProperty('usergroups')) {
        if (resp.usergroups.length > 0) {
          this.searchedAvailableUserGroup = [];
          resp.usergroups.forEach((ele : any) => {
            if (this.selectedItems.find((item: any) => item === ele.partyGroupName) !== ele.partyGroupName) {
              this.searchedAvailableUserGroup.push(ele);
            }
          });
          if (this.searchedAvailableUserGroup.length === 0) {
            this.searchModeOn = true;
            this.listItems = [];
          } else {
            this.searchedUserGroupFlag = true;
            this.startTenantIndex = 0;
            this.endTenantIndex = 0;
            this.getListItems();
            (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
          }
        } else {
          this.searchModeOn = true;
          this.listItems = [];
        }
      } else {
        this.searchModeOn = true;
        this.listItems = [];
      }
      console.warn(resp);
    })
    .catch((err: any) => {
      console.warn('searchUserGroupInApi failed', err);
    })
    .finally(() => {
      this.$store.commit('stopLoading');
    });
  }
  searchTenants(e : any) {
    console.warn('searced');
    this.searchedValue = e;
  }

  changeExpand(e : any) {
    this.isExpandSearchFilter = !this.isExpandSearchFilter;
    if (this.isExpandSearchFilter) {
      this.enterNewUserGroup = false;
    }
    if (this.isExpandSearchFilter) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
      this.$emit('change-tab-id', 'user-groups-help', false);
    } else {
      this.searchedUserGroupFlag ? this.handleSearchFilter('') : '';
    }
    console.warn(e);
  }

  // tslint:disable-next-line:no-unused
  closeSearchFilter(e : any) {
    if (!e) {
      this.searchedValue = '';
      this.handleSearchFilter(this.searchedValue);
    } else {
      this.handleSearchFilter(this.searchedValue);
    }
  }
  onSearchBlur() {
    if (this.searchedValue.length === 0) {
      this.isExpandSearchFilter = false;
      this.searchedUserGroupFlag ? this.handleSearchFilter('') : '';
    }
  }

  addNewUserGroup() {
    console.warn('checked');
    console.warn(this.enterNewUserGroup);
    this.enterNewUserGroup = !this.enterNewUserGroup;
    if (this.enterNewUserGroup) {
      this.closeSearchFilter(false);
      this.isExpandSearchFilter = false;
    }
    this.enterNewUserGroup ? this.focusTextField() : '';
    this.enableCreateUserGroupTooltip = false;
    this.addFlag = true;
    this.editFlag = false;
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    if (window.location.href.indexOf('create-customer') > -1) {
      // (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
      // (this.$refs.vsScroll as SwScrollView).updatePosition(0, true);
    }
    if (this.enterNewUserGroup) {
      this.$emit('change-tab-id',  'user-group-create-help', false);
    } else {
      this.$emit('change-tab-id', 'user-groups-help', false);
    }
  }

  focusTextField() {
    setTimeout(() => {
      const wrapper2 = document.getElementById('createUserGroup') as HTMLElement;
      if (wrapper2) {
        console.warn(wrapper2.children[0].getElementsByTagName('input'));
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }
  selectUserGroup(partyGroupId: string) {
    this.userGroupSelectionChanged = true;
    if (this.hoveredUserGroup.length > 0) {
      if (!this.editFlag) {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
      }
    }
    if (!this.editFlag && !this.cancelFlag) {
    // this.editFlag = false;
      if (this.selectedUserGroup[0] === partyGroupId) {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        this.$emit('change-tab-id', 'user-groups-help', false);
      } else if (this.deleteFlag) {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        this.deleteFlag = false;
        this.$emit('change-tab-id', 'user-groups-help', false);
      } else if (this.selectedUserGroup.length > 0) {
        if (!this.editing) {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
          this.oldPartyGroupId = partyGroupId;
          this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [partyGroupId]);
        } else {
          this.editing = false;
        }
      } else {
        this.$emit('change-tab-id', 'user-groups-help', false);
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', [partyGroupId]);
        this.oldPartyGroupId = partyGroupId;
      }
    } else {
      this.cancelFlag = false;
    }
    console.warn('clicked it1');
    if (!this.selectMode) {
      console.warn('clicked it2');
      if (this.upFixClass) {
        console.warn(this.$refs);
        const myScroll = this.$refs.vScroll as HTMLElement;
        const myScroll1 = this.$refs.vScroll as SwScrollView;
        myScroll1.updatePosition(myScroll.scrollTop + 45, true);
      }
      this.upFixClass =  false;
      console.warn('false');
      this.downFixClass = false;
      if (document.getElementById('selectedRow')) {
        this.selectedDiv = document.getElementById('selectedRow')!.getBoundingClientRect();
      } else if (document.getElementById('defaultGroup')) {
        this.selectedDiv = document.getElementById('defaultGroup')!.getBoundingClientRect();
      }
    }
  }

  hoverUserGroup(partyGroupId: string) {
    if (this.selectedUserGroup.length > 0) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    } else {
      if (!this.editFlag) {
      // this.editFlag = false;
        if (this.hoveredUserGroup[0] === partyGroupId) {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
        } else if (this.deleteFlag) {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
        } else if (this.hoveredUserGroup.length > 0) {
          if (!this.editing) {
            this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
            this.oldPartyGroupId = partyGroupId;
            this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', [partyGroupId]);
          } else {
            this.editing = false;
          }
        } else {
          this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', [partyGroupId]);
          this.oldPartyGroupId = partyGroupId;
        }
      }
    }
  }

  refreshData() {
    this.$emit('refresh');
  }

  unHoverUserGroup() {
    if (!this.editFlag) {
      this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    }
  }
  checkForUserGroup() {
    const name = this.listItems.find((item: any) => item.partyGroupName.toLowerCase() === this.newUserGroup.toLowerCase()) ||
     this.selectedListItems.find((item: any) => item.partyGroupName.toLowerCase() === this.newUserGroup.toLowerCase()) || '';
    return (name === '') ? false : true;
  }

  submitUserGroup(created? : any) {
    // this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    // this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    if (this.newUserGroup.trim() !== '') {
      if (this.checkForUserGroup()) {
        if (this.editUserGroupName !== this.newUserGroup) {
          this.enableCreateUserGroupTooltip = true;
          this.createUserGroupTooltipContent = 'User group name already exists';
          this.enterNewUserGroup = true;
        } else {
          if (this.selectMode) {
            (this.$refs.vsScroll as SwScrollView).updatePosition(0, true);
          }
          this.editFlag = false;
          if (!this.addFlag) { this.editing = true; }
          // if (this.addFlag) {
          // }
          this.$emit('add-new-user-group', this.newUserGroup , this.addFlag, this.editIndex, this.selectedGroupFlag);
          this.$emit('change-tab-id', 'user-groups-help', false);
          this.newUserGroup = '';
          this.enterNewUserGroup = false;
        }
      } else {
        if (this.selectMode) {
          (this.$refs.vsScroll as SwScrollView).updatePosition(0, true);
        }
        this.editFlag = false;
        if (!this.addFlag) { this.editing = true; }
        console.warn(this.newUserGroup);
        console.warn(this.addFlag);
        console.warn(this.editIndex);
        console.warn(this.selectedGroupFlag);
        this.$emit('add-new-user-group', this.newUserGroup , this.addFlag, this.editIndex, this.selectedGroupFlag);
        if (created) {
          // this.$emit('change-tab-id', 'user-groups-help', false);
        }
        // this.$emit('change-tab-id', 'user-groups-help', false);
        this.newUserGroup = '';
        this.enterNewUserGroup = false;
      }
    } else {
      this.enableCreateUserGroupTooltip = true;
      this.createUserGroupTooltipContent = 'Enter user group name';
    }
  }

  cancelUserGroup() {
    this.cancelFlag = true;
    // this.$emit('change-tab-id', 'user-groups-help', false);
    this.newUserGroup = '';
    this.enterNewUserGroup = false;
    this.editFlag = false;
  }

  selectedUserGroupName(partyGroupId: any, flag: boolean) {
    if (this.selectedUserGroup.length > 0) {
      if (this.selectedItems) {
        // tslint:disable-next-line:max-line-length
        if (this.selectedUserGroup[0] === partyGroupId && (this.lastSelected1 !== this.selectedUserGroup[0] || this.lastSelected2 !== partyGroupId || this.userGroupSelectionChanged)) {
          this.userGroupSelectionChanged = false;
          this.lastSelected1 = this.selectedUserGroup[0];
          this.lastSelected2 = partyGroupId;
          this.$emit('change-tab-id', this.selectedTab, true);
          if (this.$store.getters.isLargeCustomer) {
            this.$emit('extend-user-group', partyGroupId, flag, true);
          } else {
            this.$emit('extend-user-group', partyGroupId, flag);
          }
        }
      } else {
        // tslint:disable-next-line:max-line-length
        if (this.selectedUserGroup[0] === partyGroupId && (this.lastSelected1 !== this.selectedUserGroup[0] || this.lastSelected2 !== partyGroupId || this.userGroupSelectionChanged)) {
          // console.warn('emitted');
          this.userGroupSelectionChanged = false;
          this.lastSelected1 = this.selectedUserGroup[0];
          this.lastSelected2 = partyGroupId;
          this.$emit('change-tab-id', this.selectedTab, true);
          if (this.$store.getters.isLargeCustomer) {
            this.$emit('extend-user-group', partyGroupId, flag, true);
          } else {
            this.$emit('extend-user-group', partyGroupId, flag);
          }
        }
      }
      return this.selectedUserGroup[0] === partyGroupId;
    }
    return false;
  }

  hoveredUserGroupName(partyGroupId: string) {
    return this.hoveredUserGroup[0] === partyGroupId;
  }

  deleteUserGroup(id: any, flag: boolean) {
    const message : any = this.$t('userGroups.deleteWarning');
    confirmService.confirm({
      status: 'major',
      title: 'Delete user group',
      // tslint:disable-next-line:max-line-length
      message:
        this.availableUserGroups[id]?.usersForUserGroup?.length > 0 ?
        message :
        'Are you sure you want to delete the user group',
      buttons: [{ key: 'cancel', name: 'Cancel' }, { key: 'ok', name: 'Confirm', isDefault: true }],
    })
    .then((isConfirmed : any) => {
      if (isConfirmed === 'ok') {
        this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
        this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
        this.editIndex = id;
        this.deleteFlag = true;
        this.$emit('change-tab-id', 'user-groups-help', false);
        this.$emit('delete-user-group', this.editIndex, flag);
      }
    })
    .catch((err: any) => {
      console.warn('deleteUserGroup confirm failed', err);
    });
  }

  editUserGroup(id: any, name: string, flag: boolean) {
    this.enableCreateUserGroupTooltip = false;
    this.editIndex = id;
    this.newUserGroup = name;
    this.editUserGroupName = name;
    this.addFlag = false;
    this.editFlag = !this.editFlag;
    this.enterNewUserGroup = true;
    this.selectedGroupFlag = flag;
  }

  @Watch('updateCount')
  countUpdated() {
    if (this.updateCount) {
      this.userGroupSelectionChanged = true;
      let ugInd = this.availableUserGroups.findIndex((ele : any) => ele.partyGroupName === this.selectedUserGroup[0]);
      if (ugInd < 0) {
        ugInd = this.selectedList.findIndex((ele : any) => ele.partyGroupName === this.selectedUserGroup[0]);
        this.$set(this.selectedList, ugInd, this.selectedList[ugInd]);
      } else {
        this.$set(this.availableUserGroups, ugInd, this.availableUserGroups[ugInd]);
      }
      console.warn(this.availableUserGroups.filter((ele : any) => ele.partyGroupName === this.selectedUserGroup[0]));
      console.warn(this.selectedList.filter((ele : any) => ele.partyGroupName === this.selectedUserGroup[0]));
    }
  }

  @Watch('availableUserGroups')
  loadUserGroup() {
    console.warn('called');
    if (window.location.href.indexOf('create-customer') > -1 && this.$refs.vScroll as SwScrollView) {
      // (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
      // (this.$refs.vsScroll as SwScrollView).updatePosition(0, true);
    }
    this.listItems = [];
    console.warn(this.availableUserGroups);
    if (this.searchedUserGroupFlag) {
      this.handleSearchFilter(this.searchedValue);
    } else {
      if (this.endTenantIndex === 0) {
        if (this.availableUserGroups.length > 100) {
          this.endTenantIndex = 100;
        } else {
          this.endTenantIndex = this.availableUserGroups.length;
        }
      }
      // this.availableUserGroups.length > 100 ? this.endTenantIndex = 100 : this.endTenantIndex = this.availableUserGroups.length;
      this.getListItems();
    }
  }

  @Watch('selectedList')
  loadSelectedUserGroup() {
    if (this.selectMode) {
      this.userGroupSelectionChanged = true;
      console.warn('testedchanged --- 2');
    }
    console.warn('checked1');
    // this.selectedListItems = this.selectedList.map((obj: any) => {
    //   return {
    //     partyGroupName: obj.hasOwnProperty('partyGroupName') ? obj.partyGroupName : '',
    //     usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup : {},
    //     default: obj.isDefaultGroup === 'TRUE',
    //     renameLink: obj.renameLink,
    //     deleteLink: obj.deleteLink,
    //     setAsDefaultGroup: obj.setAsDefaultGroup,
    //   };
    // });
    this.selectedListItems = [];
    console.warn(this.selectedList);
    this.selectedList.forEach((obj : any) => {
      if (this.selectedListItems.length < this.selectedList.length) {
        this.selectedListItems.push({
          partyGroupName: obj.hasOwnProperty('partyGroupName') ? obj.partyGroupName : '',
          usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup : [],
          default: obj.isDefaultGroup.toLowerCase() === 'true',
          renameLink: obj.renameLink,
          isReadOnlyAccess: obj.isReadOnlyAccess,
          deleteLink: obj.deleteLink,
          setAsDefaultGroup: obj.setAsDefaultGroup,
          partyGroupId : obj.partyGroupId,
          totalContacts : obj.hasOwnProperty('totalContacts') ? obj.totalContacts : '0',
        });
      }
    });
  }
  @Watch('selectedItemsProp')
  loadSelectedItems() {
    this.selectedItems = this.selectedItemsProp;
  }

  @Watch('scrollUserGroupToTop')
  setScrollUserGroupToTop() {
    if (this.scrollUserGroupToTop) {
      this.startTenantIndex = 0;
      this.endTenantIndex = 0;
      this.getListItems();
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    }
  }

  created() {
    const tempObj: any = localStorage.getItem(currentUserKey);
    const userInfoObtained: any = JSON.parse(tempObj);
    if (userInfoObtained && userInfoObtained.token) {
      const decodedToken: any = decode(userInfoObtained.token);
      this.organizationId = decodedToken?.orgid || '';
    }
    if (this.hideRefresh) {
      this.hideRefreshButton = this.hideRefresh;
    }
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    this.$store.dispatch('MswUserGroupStoreModule/userGroupHovered', []);
    this.loadUserGroupFirst();
    this.loadSelectedUserGroup();
    this.loadSelectedItems();
    console.warn('list of items', this.selectedList);
    // this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', this.selectedUserGroup);
  }

  loadUserGroupFirst() {
    console.warn('created');
    if (window.location.href.indexOf('create-customer') > -1 && this.$refs.vScroll as SwScrollView) {
      (this.$refs.vScroll as SwScrollView).updatePosition(0, true);
    }
    // this.listItems = this.availableUserGroups.map((obj: any) => {
    //   return {
    //     partyGroupName: obj.hasOwnProperty('partyGroupName') ? obj.partyGroupName : '',
    //     usersForUserGroup: obj.hasOwnProperty('usersForUserGroup') ? obj.usersForUserGroup  : {},
    //     isDefaultGroup: obj.hasOwnProperty('isDefaultGroup') ? obj.isDefaultGroup : 'FALSE',
    //     renameLink: obj.renameLink,
    //     deleteLink: obj.deleteLink,
    //     setAsDefaultGroup: obj.setAsDefaultGroup,
    //   };
    // });
    this.listItems = [];
    this.startTenantIndex = 0;
    // console.warn(this.availableUserGroups[0]);
    // console.warn(this.availableUserGroups[0].hasOwnProperty('partyGroupName'));
    if (!this.selectMode) {
      if (this.availableUserGroups.length < 100) {
        for (let i = 0; i < this.availableUserGroups.length ; i += 1) {
          if (this.filterMsspEntries(this.availableUserGroups[i]) && this.filterByOrganizationId(this.availableUserGroups[i])) {
            this.listItems.push({
              partyGroupName: this.availableUserGroups[i].hasOwnProperty('partyGroupName') ? this.availableUserGroups[i].partyGroupName : '',
              usersForUserGroup: this.availableUserGroups[i].hasOwnProperty('usersForUserGroup') ? this.availableUserGroups[i].usersForUserGroup  : [],
              isDefaultGroup: this.availableUserGroups[i].hasOwnProperty('isDefaultGroup') ? this.availableUserGroups[i].isDefaultGroup : 'FALSE',
              renameLink: this.availableUserGroups[i].renameLink,
              deleteLink: this.availableUserGroups[i].deleteLink,
              setAsDefaultGroup: this.availableUserGroups[i].setAsDefaultGroup,
              partyGroupId : this.availableUserGroups[i].partyGroupId,
              isAffilated: this.availableUserGroups[i].isAffilated || 'NO',
              isAutoAffiliated: this.availableUserGroups[i].isAutoAffiliated || 'NO',
              totalContacts : this.availableUserGroups[i].hasOwnProperty('totalContacts') ? this.availableUserGroups[i].totalContacts : '0',
              isReadOnlyAccess: this.availableUserGroups[i].hasOwnProperty('isReadOnlyAccess') && this.availableUserGroups[i].isReadOnlyAccess,
              isSharedGroup: this.availableUserGroups[i].hasOwnProperty('isSharedGroup') && this.availableUserGroups[i].isSharedGroup,
            });
          }
        }
        this.endTenantIndex = this.availableUserGroups.length;
      } else {
        this.endTenantIndex = 100;
        console.warn(this.availableUserGroups);
        for (let i = this.startTenantIndex; i < this.endTenantIndex ; i += 1) {
          if (this.filterMsspEntries(this.availableUserGroups[i]) && this.filterByOrganizationId(this.availableUserGroups[i])) {
            this.listItems.push({
              partyGroupName: this.availableUserGroups[i].hasOwnProperty('partyGroupName') ? this.availableUserGroups[i].partyGroupName : '',
              usersForUserGroup: this.availableUserGroups[i].hasOwnProperty('usersForUserGroup') ? this.availableUserGroups[i].usersForUserGroup  : [],
              isDefaultGroup: this.availableUserGroups[i].hasOwnProperty('isDefaultGroup') ? this.availableUserGroups[i].isDefaultGroup : 'FALSE',
              renameLink: this.availableUserGroups[i].renameLink,
              deleteLink: this.availableUserGroups[i].deleteLink,
              setAsDefaultGroup: this.availableUserGroups[i].setAsDefaultGroup,
              partyGroupId : this.availableUserGroups[i].partyGroupId,
              isAffilated: this.availableUserGroups[i].isAffilated || 'NO',
              isAutoAffiliated: this.availableUserGroups[i].isAutoAffiliated || 'NO',
              totalContacts : this.availableUserGroups[i].hasOwnProperty('totalContacts') ? this.availableUserGroups[i].totalContacts : '0',
              isReadOnlyAccess: this.availableUserGroups[i].hasOwnProperty('isReadOnlyAccess') && this.availableUserGroups[i].isReadOnlyAccess,
              isSharedGroup: this.availableUserGroups[i].hasOwnProperty('isSharedGroup') && this.availableUserGroups[i].isSharedGroup,
            });
          }
        }
        // this.listItems = this.listItems.sort((a:any, b:any) => {
        //   if (a.partyGroupName !== 'default' && a.partyGroupName !== 'default') {
        //     const textA = a.partyGroupName.toUpperCase();
        //     const textB = b.partyGroupName.toUpperCase();
        //     return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        //   }
        // });
        console.warn(this.listItems);
      }
    } else {
      console.warn('created 1');
      this.getListItems();
    }
    console.warn('dasdsa', this.listItems);
  }

  filterMsspEntries(entry: any) {
    if (!this.selectMode) {
      return true;
    }
    return (entry.MSSPID === '' || entry.MSSPID === undefined) ? true : false;
  }

  filterByOrganizationId(entry: any) {
    if (!this.selectMode || !this.organizationId) {
      return true;
    }
    if (!this.organizationId) {
      return true;
    }
    return this.organizationId === (entry?.orgID || '');
  }

  onSelect(id: any, name: string) {
    console.warn('addeded');
    this.$store.dispatch('MswUserGroupStoreModule/userGroupSelected', []);
    this.deleteFlag = true;
    if (this.selectedItems.find((item: any) => item === name) === name) {
      console.warn(id);
      if (this.searchedUserGroupFlag) {
        const ind = this.availableUserGroups.findIndex((ele : any) => ele.partyGroupName === name);
        if (ind > -1) {
          this.$emit('on-select', ind, true);
        } else {
          this.$emit('on-select', id, true);
        }
      } else {
        this.$emit('on-select', id, true);
      }
      // this.$emit('on-select', id, true);
    } else {
      this.$emit('on-select', id, false);
    }
  }

  makeDefault(index: any, flag: boolean) {
    const list = flag ? this.selectedListItems : this.listItems;
    const targetGroup = list && list[index];
    if (!targetGroup) { return; }
    const partyGroupId = targetGroup.partyGroupId;
    const targetName = targetGroup.partyGroupName;
    const currentDefault = this.selectedListItems.find((g: any) => g.default)
      || this.listItems.find((g: any) => g.isDefaultGroup && g.isDefaultGroup.toLowerCase() === 'true');
    // tslint:disable-next-line:no-unused
    const innerHTML = currentDefault
      ? `${(this.$t('userGroups.warningNote').toString())} <b>${currentDefault.partyGroupName}</b> to <b>${targetName}</b> ?`
      : `Are you sure you want to change the default user group to <b>${targetName}</b> ?`;
    // tslint:disable-next-line:no-unused
    const message = (h: CreateElement): VNode => h('div', { domProps: { innerHTML } });
    confirmService.confirm({
      message,
      status: 'informational',
      title: (this.$t('products.confirmation').toString()),
      buttons: [{ key: 'cancel', name: 'Cancel', isDefault: true }, { key: 'yes', name: 'Yes' }],
    })
    .then((key) => {
      if (key === 'yes') {
        this.$emit('make-default', partyGroupId, flag);
      }
    })
    .catch((err: any) => {
      console.warn('makeDefault confirm failed', err);
    });
  }

  onEnterGrpName(value: string) {
    this.enableCreateUserGroupTooltip = false;
    if (value.trim() !== '') {
      if (value.length > 50) {
        this.enableCreateUserGroupTooltip = true;
        this.createUserGroupTooltipContent = 'User group name should not exceed 50 characters';
        return;
      }
    }
    this.newUserGroup = value;
  }

  get createUserGroupTooltipValue() : TooltipDirValues  {
    return {
      enabled: this.enableCreateUserGroupTooltip,
      placement: 'top',
      persistent: true,
      compact: true,
      content: this.createUserGroupTooltipContent,
    };
  }

  // tslint:disable-next-line:no-unused
  onScrollView(e? : any) {
    const myScroll = this.$refs.vScroll as HTMLElement;
    // console.warn(myScroll.scrollTop);
    // console.warn(document.getElementById('scrollNav')!.getBoundingClientRect().height);
    // console.warn(myScroll.scrollHeight);
    // console.warn((myScroll.scrollTop + document.getElementById('scrollNav')!.getBoundingClientRect().height) - myScroll.scrollHeight);
    let startOffset;
    let endOffSet;
    if (!this.selectMode) {
      startOffset = -10;
      endOffSet = 0;
    } else {
      startOffset = 10;
      endOffSet = 120;
    }
    const availableGroupsLength = this.searchedUserGroupFlag ? this.searchedAvailableUserGroup.length : this.availableUserGroups.length;
    if (((myScroll.scrollTop + document.getElementById('scrollNav')!.getBoundingClientRect().height) - myScroll.scrollHeight > startOffset) &&
      (myScroll.scrollTop + document.getElementById('scrollNav')!.getBoundingClientRect().height) - myScroll.scrollHeight < endOffSet) {
      if (availableGroupsLength - this.endTenantIndex >= 30 && !this.showLoader) {
        const myScroll = this.$refs.vScroll as HTMLElement;
        const myScroll1 = this.$refs.vScroll as SwScrollView;
        this.showLoader = true;
        setTimeout(() => {
          this.endTenantIndex = this.endTenantIndex + 30;
          this.startTenantIndex = this.startTenantIndex + 30;
          this.getListItems();
          console.warn('start --', this.startTenantIndex);
          console.warn('end -- ', this.endTenantIndex);
          console.warn(this.listItems);
          console.warn(this.availableUserGroups);
          myScroll1.updatePosition(myScroll.scrollTop - (45 * 30), true);
          this.showLoader = false;
        },         1000);
        // tslint:disable-next-line:max-line-length
      } else if ((availableGroupsLength - this.endTenantIndex < 30 && availableGroupsLength - this.endTenantIndex > 0) && !this.showLoader) {
        const myScroll = this.$refs.vScroll as HTMLElement;
        const myScroll1 = this.$refs.vScroll as SwScrollView;
        this.showLoader = true;
        setTimeout(() => {
            // if (this.customerListId !== -1) {
            //   this.selectedProductGroup = this.customerList.filter((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
            // } else {
            //   this.selectedProductGroup = null;
            // }
          const endIndexOffset = availableGroupsLength - this.endTenantIndex;
          this.endTenantIndex = this.endTenantIndex + endIndexOffset;
          this.startTenantIndex = this.startTenantIndex + endIndexOffset;
          this.getListItems();
          console.warn('start --', this.startTenantIndex);
          console.warn('end -- ', this.endTenantIndex);
          console.warn(this.listItems);
          console.warn(this.availableUserGroups);
          myScroll1.updatePosition(myScroll.scrollTop - (45 * endIndexOffset), true);
          this.showLoader = false;
        },         1000);
      }
    } else if (myScroll.scrollTop === 0 && !this.showTopLoader) {
      if (this.startTenantIndex >= 30) {
        const myScroll = this.$refs.vScroll as HTMLElement;
        const myScroll1 = this.$refs.vScroll as SwScrollView;
        this.showTopLoader = true;
        setTimeout(() => {
          // if (this.customerListId !== -1) {
          //     this.selectedProductGroup = this.customerList.filter((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
          //   } else {
          //     this.selectedProductGroup = null;
          //   }
          this.endTenantIndex = this.endTenantIndex - 30;
          this.startTenantIndex = this.startTenantIndex - 30;
          this.getListItems();
          console.warn('start --', this.startTenantIndex);
          console.warn('end -- ', this.endTenantIndex);
          console.warn(this.listItems);
          console.warn(this.availableUserGroups);
          myScroll1.updatePosition(myScroll.scrollTop + (45 * 30), true);
          this.showTopLoader = false;
        },         1000);
      } else if ((this.startTenantIndex < 30 && this.startTenantIndex > 0) && !this.showTopLoader) {
        const myScroll = this.$refs.vScroll as HTMLElement;
        const myScroll1 = this.$refs.vScroll as SwScrollView;
        this.showTopLoader = true;
        setTimeout(() => {
            // if (this.customerListId !== -1) {
            //   this.selectedProductGroup = this.customerList.filter((ele : any) => ele.productGroupName === this.selectedCustomer[0]);
            // } else {
            //   this.selectedProductGroup = null;
            // }
          const startIndex = this.startTenantIndex;
          this.endTenantIndex = this.endTenantIndex - this.startTenantIndex ;
          this.startTenantIndex = 0;
          this.getListItems();
          console.warn('start --', this.startTenantIndex);
          console.warn('end -- ', this.endTenantIndex);
          console.warn(this.listItems);
          console.warn(this.availableUserGroups);
          myScroll1.updatePosition(myScroll.scrollTop + (45 * startIndex), true);
          this.showTopLoader = false;
        },         1000);
      }
    }
    if (!this.selectMode) {
      if (document.getElementById('selectedRow')) {
        this.selectedDiv = document.getElementById('selectedRow')!.getBoundingClientRect();
        const container = document.getElementById('scrollNav')!.getBoundingClientRect();
        const ind = this.listItems.findIndex((ele: any) => ele.partyGroupId === this.selectedUserGroup[0]);
        let nextEle : any;
        let prevEle : any;
        // tslint:disable-next-line:prefer-template
        if (document.getElementById('unSelected' + (ind + 1))) {
        // tslint:disable-next-line:prefer-template
          nextEle = document.getElementById('unSelected' + (ind + 1))!.getBoundingClientRect();
        } else {
          // tslint:disable-next-line:prefer-template
          prevEle = document.getElementById('unSelected' + (ind - 1))!.getBoundingClientRect();
        }
        if (container.top >= this.selectedDiv.top) {
          if (ind === 0) {
            this.upFixClass = this.upFixClass ? container.top <= nextEle.top ? false : true : true;
            console.warn('false');

          } else {
            this.upFixClass = this.upFixClass ? container.top <= nextEle.top - nextEle.height ? false : true : true;
            console.warn('false');

          }
        } else {
          this.upFixClass =  false;
          console.warn('false');

        }
        if (container.bottom <= this.selectedDiv.bottom) {
          if (nextEle) {
            console.warn('ctnr btm ', (container.bottom + 30));
            console.warn('nxt top ', nextEle.top);
            console.warn(this.downFixClass);
            this.downFixClass =  container.bottom >= nextEle.top - 45   ? false : true ;
          } else {
            this.downFixClass = Math.abs(prevEle.bottom - container.bottom) > 55 ? true : false;
          }
        } else {
          this.downFixClass = false;
        }
      } else if (document.getElementById('defaultGroup')) {
        this.selectedDiv = document.getElementById('defaultGroup')!.getBoundingClientRect();
        const container = document.getElementById('scrollNav')!.getBoundingClientRect();
        // tslint:disable-next-line:no-unused
        let nextEle : any;
        nextEle = document.getElementById('unSelected0')!.getBoundingClientRect();
        if (container.top >= this.selectedDiv.top) {
          this.upFixClass =  true;
        } else {
          this.upFixClass =  false;
          console.warn('false');

        }
      }
      // console.warn('upfix', this.upFixClass);
      // console.warn('downfix', this.downFixClass);
    }
  }

  getListItems() {
    console.warn('updated');
    console.warn(this.startTenantIndex);
    console.warn(this.endTenantIndex);
    console.warn(this.availableUserGroups);
    console.warn(this.searchedAvailableUserGroup);
    // tslint:disable-next-line:max-line-length
    if (this.searchedUserGroupFlag) {
      // tslint:disable-next-line:max-line-length
      this.endTenantIndex === 0 ? this.searchedAvailableUserGroup.length >= 100 ? this.endTenantIndex = 100 : this.endTenantIndex = this.searchedAvailableUserGroup.length : this.endTenantIndex;
      this.listItems = [];
      for (let i = this.startTenantIndex; i < this.endTenantIndex ; i += 1) {
        this.listItems.push({
          partyGroupName: this.searchedAvailableUserGroup[i].hasOwnProperty('partyGroupName') ? this.searchedAvailableUserGroup[i].partyGroupName : '',
          // tslint:disable-next-line:max-line-length
          usersForUserGroup: this.searchedAvailableUserGroup[i].hasOwnProperty('usersForUserGroup') && this.searchedAvailableUserGroup[i].usersForUserGroup !== undefined ? this.searchedAvailableUserGroup[i].usersForUserGroup  : [],
          isDefaultGroup: this.searchedAvailableUserGroup[i].hasOwnProperty('isDefaultGroup') ? this.searchedAvailableUserGroup[i].isDefaultGroup : 'FALSE',
          renameLink: this.searchedAvailableUserGroup[i].renameLink,
          deleteLink: this.searchedAvailableUserGroup[i].deleteLink,
          setAsDefaultGroup: this.searchedAvailableUserGroup[i].setAsDefaultGroup,
          partyGroupId : this.searchedAvailableUserGroup[i].partyGroupId,
          isAffilated: this.searchedAvailableUserGroup[i].isAffilated || 'NO',
          isAutoAffiliated: this.searchedAvailableUserGroup[i].isAutoAffiliated || 'NO',
          totalContacts : this.searchedAvailableUserGroup[i].hasOwnProperty('totalContacts') ? this.searchedAvailableUserGroup[i].totalContacts : '0',
          isReadOnlyAccess: this.searchedAvailableUserGroup[i].hasOwnProperty('isReadOnlyAccess') && this.searchedAvailableUserGroup[i].isReadOnlyAccess,
        });
      }
      console.warn(this.listItems);
      if (this.selectedUserGroup.length > 0) {
        const i = this.searchedAvailableUserGroup.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
        if (i > -1) {
          if (this.upFixClass) {
            const index1 = this.listItems.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
            if (index1 < 0) {
              this.listItems.unshift(this.searchedAvailableUserGroup[i]);
              console.warn(this.listItems);
            }
          } else {
            const index2 = this.listItems.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
            if (index2 < 0) {
              const obj = this.searchedAvailableUserGroup[i];
              if (obj.hasOwnProperty('totalContacts')) {
                this.listItems.push(this.searchedAvailableUserGroup[i]);
              } else {
                obj['totalContacts'] = '0';
                this.listItems.push(obj);
              }
              console.warn(this.listItems);
            }
          }
        }
        console.warn(this.upFixClass);
        console.warn(this.downFixClass);
      }
      console.warn(this.listItems);
    } else {
      // tslint:disable-next-line:max-line-length
      // this.endTenantIndex === 0 ? this.availableUserGroups.length >= 100 ? this.endTenantIndex = 100 : this.endTenantIndex = this.availableUserGroups.length : this.endTenantIndex;
      if (this.endTenantIndex === 0) {
        if (this.availableUserGroups.length > 100) {
          this.endTenantIndex = 100;
        } else {
          this.endTenantIndex = this.availableUserGroups.length;
        }
      }
      this.listItems = [];
      for (let i = this.startTenantIndex; i < this.endTenantIndex && i < this.availableUserGroups.length; i += 1) {
        if (this.filterMsspEntries(this.availableUserGroups[i])) {
          this.listItems.push({
            partyGroupName: this.availableUserGroups[i].hasOwnProperty('partyGroupName') ? this.availableUserGroups[i].partyGroupName : '',
            usersForUserGroup: this.availableUserGroups[i].hasOwnProperty('usersForUserGroup') && this.availableUserGroups[i].usersForUserGroup !== undefined ? this.availableUserGroups[i].usersForUserGroup  : [],
            isDefaultGroup: this.availableUserGroups[i].hasOwnProperty('isDefaultGroup') ? this.availableUserGroups[i].isDefaultGroup : 'FALSE',
            renameLink: this.availableUserGroups[i].renameLink,
            deleteLink: this.availableUserGroups[i].deleteLink,
            setAsDefaultGroup: this.availableUserGroups[i].setAsDefaultGroup,
            partyGroupId : this.availableUserGroups[i].partyGroupId,
            isAffilated: this.availableUserGroups[i].isAffilated || 'NO',
            isAutoAffiliated: this.availableUserGroups[i].isAutoAffiliated || 'NO',
            totalContacts : this.availableUserGroups[i].hasOwnProperty('totalContacts') ? this.availableUserGroups[i].totalContacts : '0',
            isReadOnlyAccess: this.availableUserGroups[i].hasOwnProperty('isReadOnlyAccess') && this.availableUserGroups[i].isReadOnlyAccess,
          });
        }
      }
      if (this.selectedUserGroup.length > 0) {
        const i = this.availableUserGroups.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
        if (i > -1) {
          if (this.upFixClass) {
            const index1 = this.listItems.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
            if (index1 < 0) {
              this.listItems.unshift(this.availableUserGroups[i]);
            }
          } else {
            const index2 = this.listItems.findIndex((ele : any) => ele.partyGroupId === this.selectedUserGroup[0]);
            if (index2 < 0) {
              const obj = this.availableUserGroups[i];
              if (obj.hasOwnProperty('totalContacts')) {
                this.listItems.push(this.availableUserGroups[i]);
              } else {
                obj['totalContacts'] = '0';
                this.listItems.push(obj);
              }
            }
          }
        }
        console.warn(this.upFixClass);
        console.warn(this.downFixClass);
      }
      console.warn(this.listItems);
    }
    console.warn('final list item', this.listItems);
    return this.listItems;
  }

  mounted() {
    this.availableUserGroups = this.availableUserGroups.sort((a:any, b:any) => {
      if (a.partyGroupName !== 'default' && a.partyGroupName !== 'default') {
        const textA = a.partyGroupName.toUpperCase();
        const textB = b.partyGroupName.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
      }
    });
    this.showAffiliateDropdown && this.onChangeAffiliate();
  }
}
